import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import Audioknigi from '@/components/screens/audioknigi/Audioknigi';
import { BOOKS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IBookPage } from '@/interfaces/booksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface AudioBooksPage extends IWidgetsSideBar {
  books: IBookPage;
}

const AudioBooksPage: NextPage<AudioBooksPage> = ({ books, todayWidget, popularBooksWidget }) => {
  return <Audioknigi books={books} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} sortingName="сначала новые" />;
};

export const getStaticProps: GetStaticProps = async () => {
  const [booksRes] = await Promise.all([fetch(`${API_URL}satellite/books?book_type=audio_book&page=1&page_size=${BOOKS_FOR_PAGE}&sort_field=created_at&sort_reversed=true`)]);
  const [books] = await Promise.all([booksRes.json()]);

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { books, todayWidget, popularBooksWidget }, revalidate: REVALIDATE_TIME };
};

export default AudioBooksPage;
